import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  Select
} from '@chakra-ui/react';
import axiosInstance from '../services/axiosInstance';

const CreateUserFromRegistrationModal = ({ isOpen, onClose, registration, onSuccess }) => {
  const [formData, setFormData] = useState({
    username: registration?.studentName || '',
    email: registration?.email || '',
    password: '',
    parentPhoneNumber: registration?.parentPhone || '',
    role: 'student'
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.username || !formData.email || !formData.password) {
      toast({ title: 'يرجى ملء جميع الحقول الأساسية', status: 'warning' });
      return;
    }
    setLoading(true);
    try {
      // 1. Create user
      const userRes = await axiosInstance.post('/auth/register', formData);

      // 2. If opened from a registration request, update its status to enrolled
      if (registration?._id) {
        await axiosInstance.put(`/registrations/${registration._id}/status`, {
          status: 'enrolled',
          notes: `تم إنشاء حساب المستخدم بنجاح (${userRes.data.username || formData.username})`
        });
      }

      toast({ title: 'تم إنشاء الحساب بنجاح', status: 'success' });
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      toast({
        title: 'خطأ',
        description: error.response?.data?.message || 'حدث خطأ أثناء إنشاء الحساب',
        status: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} dir="rtl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>إنشاء حساب للمستخدم</ModalHeader>
        <ModalCloseButton left={3} right="unset" />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>اسم المستخدم</FormLabel>
              <Input name="username" value={formData.username} onChange={handleChange} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>البريد الإلكتروني</FormLabel>
              <Input name="email" type="email" value={formData.email} onChange={handleChange} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>كلمة المرور</FormLabel>
              <Input name="password" type="password" value={formData.password} onChange={handleChange} />
            </FormControl>
            <FormControl>
              <FormLabel>هاتف ولي الأمر</FormLabel>
              <Input name="parentPhoneNumber" value={formData.parentPhoneNumber} onChange={handleChange} />
            </FormControl>
            <FormControl>
              <FormLabel>الدور</FormLabel>
              <Select name="role" value={formData.role} onChange={handleChange}>
                <option value="student">تلميذ</option>
                <option value="instructor">أستاذ</option>
                <option value="admin">مشرف</option>
              </Select>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose} ml={3}>إلغاء</Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>إنشاء الحساب</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateUserFromRegistrationModal;
